import { makeStyles } from '@rbx/ui';

const useOperationStyles = makeStyles()((theme) => ({
  accordion: {
    padding: '4px',
    '&.Mui-expanded': {
      padding: '4px',
    },
    backgroundColor: theme.palette.surface[100],
    '&.MuiAccordion-rounded': {
      borderRadius: '8px',
    },
  },
  accordionSummary: {
    margin: 0,
    padding: 0,
    '&.Mui-expanded': {
      margin: 0,
      padding: 0,
    },
    '& .MuiAccordionSummary-content': {
      margin: '8px',
      padding: 0,
      '&.Mui-expanded': {
        margin: '8px',
        padding: 0,
      },
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      position: 'absolute',
      top: '4px',
      right: '4px',
      '& .MuiSvgIcon-root': {
        width: '24px',
        height: '24px',
      },
    },
  },
  accordionDetails: {
    padding: 0,
    margin: '8px',
  },
}));

export default useOperationStyles;
